import { IFilterOrderBy } from 'angular';

export interface ITableColumn {
  name: string;
  sortField?: string;
}

export abstract class AbstractSortTableCtrl<T = any> {
  abstract tableColumns: ITableColumn[];
  sortField: string = null;
  sortReverse: boolean = false;
  clientSort: boolean = true;
  abstract _data: T[];

  protected constructor(protected orderByFilter: IFilterOrderBy) {}

  changeSorting(sortField: string) {
    if (!sortField) {
      return;
    } else if (sortField === 'assessment') {
      this.sortField = this.sortField === 'likes' ? 'dislikes' : 'likes';
      this.sortTable();
      return;
    }
    this.sortReverse = this.sortField === sortField ? !this.sortReverse : false;
    this.sortField = sortField;
    this.sortTable();
  }

  sortTable() {
    if (this.sortField) {
      this.onSortColumn();
    }
  }

  abstract onSortColumn();

  getColumnClasses(column: ITableColumn): { [key: string]: boolean } {
    return {
      sortable: !!column.sortField,
      'sort-asc':
        column.sortField === this.sortField && this.sortReverse === false,
      'sord-desc':
        column.sortField === this.sortField && this.sortReverse === true,
      'sort-likes':
        column.sortField === 'assessment' && this.sortField === 'likes',
      'sord-dislikes':
        column.sortField === 'assessment' && this.sortField === 'dislikes'
    };
  }
}



// WEBPACK FOOTER //
// ./app/shared/abstract/abstract-sort-table.ctrl.ts